import MUITooltip from '@mui/material/Tooltip';
import { useEffect, useRef, useState } from 'react';

export default function Tooltip({
  children,
  tooltipActive = true,
  displayTooltipOnOverflow = false,
  ...props
}) {
  const [disableHoverListener, setDisableHoverListener] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    function handleTooltipOnOveflow() {
      if (
        tooltipRef.current.scrollWidth > tooltipRef.current.clientWidth ||
        tooltipRef.current.scrollHeight > tooltipRef.current.clientHeight
      ) {
        setDisableHoverListener(false);
      } else {
        setDisableHoverListener(true);
      }
    }

    if (tooltipRef.current && displayTooltipOnOverflow) {
      handleTooltipOnOveflow();
      window.addEventListener('resize', handleTooltipOnOveflow);
    }

    return () => {
      window.removeEventListener('resize', handleTooltipOnOveflow);
    };
  }, []);

  return (
    <MUITooltip
      ref={tooltipRef}
      disableHoverListener={disableHoverListener}
      slotProps={{
        tooltip: {
          style: {
            padding: '4px 12px',
            fontSize: '',
            borderRadius: '6px',
            border: '1px solid #EEF0F7',
            background: '#424766',
            boxShadow: '0px 12px 12px 0px rgba(177, 177, 177, 0.10)',
            margin: '4px',
            maxWidth: '642px',
            display: tooltipActive ? 'block' : 'none',
          },
        },
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 12],
              },
            },
          ],
        },
      }}
      {...props}
    >
      {children}
    </MUITooltip>
  );
}
